import { Box, styled } from "@mui/system"
import { colors } from "../../../../styles/commonStyles"
import { Typography } from "@mui/material"
import { Button } from "@mui/base"

export const TermsOFServiceBox = styled(Box)({
  backgroundColor: colors.primaryBlue,
  borderRadius: "4px 4px 0px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  //paddingBottom: "8px",
})

export const TermsOFServiceTypo = styled(Typography)({
  padding: "20px",
  color: "#fff",
  fontWeight: "bold",
  fontSize: "18px",
})

export const ConditionsWrapper = styled(Box)({
  overflowY: "scroll",
  overflowX: "auto",
  padding: "0px",
})

export const ConditionsSubWrapper = styled(Box)({
  padding: "8px 20px",
})
export const ConditionsSubSubWrapper = styled(Box)({
  padding: "8px 20px",
})
export const ConditionsTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: "900",
  color: colors.primaryBlue,
  padding: "8px 0px 0px 0px",
})

export const ConditionsDescription = styled(Typography)({
  fontSize: "13px",
  paddingTop: "8px",
})

export const AgreeWrapper = styled(Box)({
  backgroundColor: "#F6FBFF",
  borderRadius: "0px 0px 4px 4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
})

export const AgreeSubWrapper = styled(Box)({
  padding: "15px",
  width: "300px",
  display: "flex",
  gap: "15px",
})

export const DeclineButton = styled(Button)({
  width: "140px",
  border: "1px solid #3366D6",
  color: "#3366D6",
  fontSize: "16px",
  padding: "10px",
  borderRadius: "4px",
  backgroundColor: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
})
export const AcceptButton = styled(Button)({
  width: "140px",

  color: "#fff",
  fontSize: "16px",
  borderRadius: "4px",
  cursor: "pointer",
  padding: "10px",
  fontWeight: "bold",
})
export const conditions = [
  {
    title: "1. Introduction",
    description: `This agreement ("Agreement") is entered into between the undersigned company, hereinafter referred to as the "Company," and the dental advisor, hereinafter referred to as the "Advisor".`,
  },
  {
    title: "2. Scope of Services",
    description: `The Advisor agrees to provide dental advisory services to the Company. The scope of services may include, but is not limited to, [list general advisory services].`,
  },
  {
    title: "3. Compensation",
    description: `The Company agrees to compensate the Advisor for their services based on mutually agreed-upon terms. Payment details and frequency will be outlined in a separate document or as agreed upon by both parties.`,
  },
  {
    title: "4. Confidentiality",
    description: `The Advisor agrees to maintain the confidentiality of any proprietary or confidential information provided by the Company. This includes, but is not limited to, patient information, business strategies, and internal processes.`,
  },
  {
    title: "5. Conflict of Interest",
    description: `The Advisor agrees to disclose any potential conflicts of interest that may arise during the course of the advisory relationship. The Company reserves the right to assess and address any conflicts of interest that may arise.`,
  },
  {
    title: "6. Term and Termination",
    description: `This Agreement shall commence on [Start Date] and continue until terminated by either party with [Specify notice period, e.g., 30 days] written notice. Either party may terminate this Agreement for cause immediately upon written notice if the other party breaches any material term of this Agreement.`,
  },
  {
    title: "7. Independent Contractor Relationship",
    description: `The Advisor is an independent contractor and not an employee of the Company. The Advisor is responsible for their own taxes and other statutory obligations.`,
  },
  {
    title: "8. Governing Law",
    description: `This Agreement shall be governed by and construed in accordance with the laws of [Specify governing jurisdiction].`,
  },
  {
    title: "9. Amendments",
    description: `No amendment or modification of this Agreement shall be valid unless in writing and signed by both parties..`,
  },
  {
    title: "10. Miscellaneous",
    description: `Any notices or communications required by this Agreement shall be in writing and delivered to the addresses provided by each party.

    By signing below, the parties acknowledge that they have read, understood, and agreed to the terms and conditions outlined in this Agreement.`,
  },
]
